import React from 'react';

function Qna(props) {
    return (
        <div></div>
    );
}

export default Qna;